module.exports = __webpack_public_path__ + "img/3-1.616965f9.png";